var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavTranscript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3184 1.20795e-05H7.7374C7.32688 -0.0011104 6.92021 0.0760072 6.54096 0.226894C6.16172 0.377782 5.81744 0.599437 5.52809 0.879012L2.58235 3.70701C2.29101 3.98491 2.06005 4.31559 1.90288 4.67986C1.7457 5.04412 1.66544 5.43473 1.66675 5.82901V18C1.65838 18.5215 1.86576 19.0248 2.24339 19.3998C2.62103 19.7747 3.13811 19.9905 3.68127 20H16.3184C16.8616 19.9905 17.3786 19.7747 17.7563 19.3998C18.1339 19.0248 18.3413 18.5215 18.3329 18V2.00001C18.3413 1.47854 18.1339 0.975163 17.7563 0.60025C17.3786 0.225336 16.8616 0.00948084 16.3184 1.20795e-05ZM6.87493 2.41401V5.00001H4.18126L6.87493 2.41401ZM3.75002 18V7.00001H6.87493C7.42745 7.00001 7.95733 6.78929 8.34802 6.41422C8.73871 6.03915 8.9582 5.53044 8.9582 5.00001V2.00001L16.2434 1.97801C16.2477 1.98461 16.2498 1.99225 16.2497 2.00001L16.3184 18H3.75002Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTranscript);
export default __webpack_public_path__ + "static/media/nav-transcript.f5f6bddbcfe77894950c0669b807c798.svg";
export { ForwardRef as ReactComponent };